module.exports = {
  systemName: '云米授权',
  systemId: '40'
}
